module.exports = {};



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/modules/_iterators.js
// module id = 242
// module chunks = 8 10 11 13 19 22 23 41